<template>
  <v-container fluid class="pa-0">
    <v-layout row>
      <v-layout column>
        <v-card>
          <v-card-title>
            <v-layout column>
            <v-layout row class="mb-2">
              <h2 class="display-1">Cancelled Shifts</h2>
              <v-spacer></v-spacer>
                <v-layout row>
                  <template>
                    <v-flex>
                      <v-menu
                        ref="startDateMenu"
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template slot="activator" slot-scope="{ on }">
                          <v-text-field
                            label="Cancelled on Starting Date"
                            format="dddd, MM DD YYYY"
                            @change="value => startDate = value"
                            :value="dateFormatted(startDate)"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </template>
                  <template>
                    <v-flex>
                      <v-menu
                        ref="endDateMenu"
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template slot="activator" slot-scope="{ on }">
                          <v-text-field
                            label="Cancelled on Ending Date"
                            format="dddd, MM DD YYYY"
                            @change="value => endDate = value"
                            :value="dateFormatted(endDate)"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </template>

                  <v-flex>
                    <v-switch
                      label="Sunset only"
                      v-model="sunsetOnly"
                    />
                  </v-flex>

                  <v-btn @click="getReports" color="primary">
                    Change Dates
                  </v-btn>
                </v-layout>
              </v-layout>
              <v-layout row justify-space-around align-center>
                <v-flex>
                  <ul class="subtle caption">
                    <li>
                      Sunset: Shift was automatically sunsetted.
                    </li>
                    <li>
                      Regular Cancellation: Greater than 1 week, any position.
                    </li>
                    <li>
                      Cancellation 1a: Less than 1 week, greater than 72 hours,
                      DVM position
                    </li>
                    <li>
                      Cancellation 1b: Less than 1 week, greater than 72 hours,
                      non-DVM position
                    </li>
                    <li>
                      Cancellation 2a: Less than 72 hours, greater than 24
                      hours, DVM position
                    </li>
                    <li>
                      Cancellation 2b: Less than 72 hours, greater than 24
                      hours, non-DVM position
                    </li>
                    <li>
                      [no level]: No employee was assigned at cancellation time
                    </li>
                  </ul>
                </v-flex>
                <v-flex>
                  <v-layout column full-width>
                  </v-layout>

                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-title>

          <v-card-text>
            <v-layout row justify-center align-center class="text-xs-center mb-4">
              <v-flex class="font-weight-light">
                {{ totalItems }} Cancellations in date range
              </v-flex>
            </v-layout>
            <v-data-table
              hide-actions
              :loading="reportsPending"
              :headers="roledHeaders"
              :items="cancels"
              :total-items="totalItems"
              item-key="id"
              class="elevation-1"
            >
              <template slot="items" slot-scope="{ item }">
                <tr>
                  <td>
                    {{ item.shift.startDatetime | moment("dddd MMMM D, YYYY h:mma") }}
                  </td>
                  <td>
                    {{ item.shift.endDatetime | moment("dddd MMMM D, YYYY h:mma") }}
                  </td>
                  <td>{{ item.shift.location }}</td>
                  <td>{{ item.shift.shiftRole }}</td>
                  <td>
                    {{ item.cancellation.level }}
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'clientDetail', params: { clientId: item.cancellation.canceller_id }}"
                    >
                      {{ item.cancellation.canceller_name }}
                    </router-link>
                  </td>
                  <td v-if="item.shift.userId">
                    <router-link
                      :to="{ name: 'employeeDetail', params: { employeeId: item.shift.userId }}"
                    >
                      {{ item.shift.workerName }}
                    </router-link>
                  </td>
                  <td v-else>
                  </td>
                  <td>{{ item.cancellation.notes }}</td>
                  <td v-if="!user.clientAdmin">
                    <span v-for="manager in item.cancellation.account_managers">
                      {{ manager.name }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-layout row justify-end align-center>
              <v-spacer/>
              <v-flex shrink v-if="pagination.rowsPerPage > 0">
                <v-pagination
                  label="Page"
                  v-model="pagination.page"
                  :length="totalPages"
                />
              </v-flex>
              <v-spacer/>
              <v-flex shrink>
                <v-select
                  :items="pageOptions"
                  v-model="pagination.rowsPerPage"
                  label="Rows per Page"
                />
              </v-flex>
            </v-layout>
          </v-card-text>

        </v-card>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import ApiField from '@/components/base/api-field.vue';
  import {mapState, mapGetters} from 'vuex';
  import PunchRow from '@/components/calendar/punch.vue';
  import {ExportToCsv} from 'export-to-csv';

  export default {
    components: {
      PunchRow,
      ApiField,
    },
    computed: {
      ...mapState('userAuth', ['user']),
      rowsPerPage() {
        return this.pagination.rowsPerPage;
      },
      currentPage() {
        return this.pagination.page;
      },
      totalPages() {
        if (this.totalItems < 1) {
          return 1
        }
        return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
      },
      roledHeaders() {
        if (this.user.clientAdmin) {
          const trimmedHeaders = this.headers.filter((h) => h.text != 'VSS Managers')
          return trimmedHeaders
        }
        return this.headers
      }
    },
    mounted() {
      this.getReports();
    },
    watch: {
      rowsPerPage() {
        this.page = 1
        this.getReports()
      },
      currentPage() {
        this.getReports()
      }
      //pagination: {
        //handler () {
          //this.getReports()
        //},
        //deep: true,
      //},
    },
    data: function() {
      return {
        pageOptions: [
          {text: "5", value: 5 },
          {text: "10", value: 10},
          {text: "25", value: 25 },
          {text: "50", value: 50 },
          {text: "All", value: -1 },
        ],
        reportsPending: false,
        sunsetOnly: false,
        cancels: [],
        totalItems: 0,
        startDateMenu: false,
        endDateMenu: false,
        startDate: this.$moment().subtract(2, "weeks").format('YYYY-MM-DD'),
        endDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),
        pagination: {
          rowsPerPage: 10,
          page: 1,
        },
        headers: [
          {text: 'Scheduled Start', sortable: false, value: 'shift.startDatetime'},
          {text: 'Scheduled End', sortable: false, value: 'shift.endDatetime'},
          {text: 'Shift Location', sortable: false, value: 'shift.location'},
          {text: 'Shift Position', sortable: false, value: 'shift.shiftRole'},
          {
            text: 'Cancellation Level',
            sortable: true,
            value: 'cancellation.cancellation_level',
          },
          {
            text: 'Cancelled By',
            sortable: false,
            value: 'shift.cancellation.canceller_name',
          },
          {
            text: 'Assigned Employee',
            sortable: false,
            value: 'shift.workerName',
          },
          {
            text: 'Cancellation Notes',
            sortable: false,
            value: 'canellation.notes',
          },
          {
            text: 'VSS Managers',
            sortable: false,
            value: 'cancellation.account_managers',
          },
        ],
      };
    },

    methods: {
      dateFormatted: function (date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : ''
      },

      getReports() {
        this.reportsPending = true;
        this.$store
          .dispatch('reports/getShiftCancellations', {
            start_date: this.startDate,
            end_date: this.endDate,
            sunset_only: this.sunsetOnly,
            // Y = Math.ceil(this.totalItems / this.pagination.rowsPerPage) // remainder
            // X = (total - Y)
            // (page * X) / page
            // math.ceil( above )
            limit: this.pagination.rowsPerPage,
            offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          })
          .then(res => {
            this.cancels = res.cancellations;
            //this.pagination.totalItems = res.total;
            this.totalItems = res.total;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(res => {
            this.reportsPending = false;
          });
      },
    },
  };
</script>

<style scoped></style>
